import React, { useContext, useEffect, useState } from 'react';

import { Check } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { userType } from '../../../constants/Enum';
import { sideBarWidth, spHeaderHeight } from '../../../constants/Location';
import { AuthContext } from '../../../contexts/auth';
import { browserBack } from '../../../modules/error';

import CustomSnackbar from '../../uiParts/CustomSnackbar';
import SideBar from '../../uiParts/SideBar';
import CustomHead from '../CustomHead';

const styles = {
  container: {
    '@media screen and (min-width:961px)': {
      ml: sideBarWidth,
      height: '100vh'
    },
    '@media screen and (max-width:960px)': {
      mt: spHeaderHeight
    },
    direction: 'column',
    justifyContent: 'center',
    height: `calc(100vh - ${spHeaderHeight})`,
    minHeight: '100vh'
  },
  body: {
    '@media screen and (max-width:600px)': {
      width: '343px',
      mt: '64px'
    },
    textAlign: 'center',
    maxWidth: '560px',
    width: '95%',
    alignItems: 'center',
    mt: '160px'
  },
  checkIcon: {
    '@media screen and (max-width:600px)': {
      height: '64px'
    },
    height: '80px',
    width: '100%',
    color: gray100
  },
  title: {
    '@media screen and (max-width:600px)': {
      fontSize: '24px',
      m: '34px auto 0'
    },
    fontWeight: 500,
    color: gray100,
    fontSize: '24px',
    mt: '34px',
    textAlign: 'center'
  },
  text: {
    fontSize: '16px',
    color: gray100,
    mt: '24px',
    textAlign: 'center',
    fontWeight: 400
  },
  button: {
    maxWidth: '560px',
    width: '95%',
    mt: '80px',
    ...primaryButtonOutlinedColor
  }
};

const AdminProductComplete: React.FC = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const currentUserType = Number(localStorage.getItem('user_type'));
  const navigate = useNavigate();

  useEffect(() => {
    // 未ログイン時はログイン画面に飛ばす
    if (!isLoggedIn) return navigate('/auth/login');
    // 事務局画面で事務局ユーザーではない場合は、ホームに飛ばす
    if (currentUserType !== userType.admin) return navigate('/home');
  }, [isLoggedIn, currentUserType]);

  const [finishStatus, setFinishStatus] = useState(false);
  const [open, setOpen] = useState(false);

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    if (!finishStatus) {
      e.preventDefault();
      setOpen(true);
      window.history.pushState(null, '', window.location.pathname);
      setFinishStatus(false);
    }
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  let status;
  const location = useLocation();
  const state = location.state as { status: string };
  if (state !== null && state !== undefined) {
    status = state.status;
  }

  const titleText = (() => {
    switch (status) {
      case 'register':
        return '建材を登録しました';
      case 'draft':
        return '建材を下書き保存しました';
      case 'update':
        return '建材を変更しました';
      case 'delete':
        return '建材を削除しました';
      default:
        return '';
    }
  })();

  return (
    <>
      <CustomHead title="事務局 建材登録・編集完了 | CMCOS[コムコス]" />
      <Grid container>
        <SideBar />
        <Grid container sx={styles.container}>
          <Grid item sx={styles.body}>
            <Check sx={styles.checkIcon} />
            <Typography sx={styles.title}>{titleText}</Typography>
            <Button
              fullWidth
              onClick={() => {
                navigate('/operator/material');
              }}
              sx={styles.button}
              variant="outlined"
            >
              建材管理へ
            </Button>
          </Grid>
        </Grid>
        <CustomSnackbar
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          open={open}
          text={browserBack}
        />
      </Grid>
    </>
  );
};

export default AdminProductComplete;
